import { find } from 'lodash-es'
import { DealerAPI } from 'src/api'
import $router from 'src/router'
import { useCustomGroup } from 'pages/CustomGroups/composables/useCustomGroup.js'
import { AuthService, NotifyService } from 'src/services'

export default {
  namespaced: true,
  state: {
    dealers: [],
    onboardings: [],
  },
  mutations: {
    SET_DEALERS(state, payload) {
      state.dealers = payload
    },
    SET_ONBOARDINGS(state, payload) {
      state.onboardings = payload
    },
  },
  actions: {
    async list({ commit }) {
      const data = await DealerAPI.getFullList()
      commit('SET_DEALERS', data.active || [])
      commit('SET_ONBOARDINGS', data.onboarding || [])

      // Auto redirect to onboarding if no active dealer groups
      if (
        (!data.active || data.active.length === 0) &&
        data.onboarding &&
        data.onboarding.length > 0
      ) {
        // Check if we're not already on an onboarding route
        if (!$router.currentRoute.value.name?.startsWith('onboarding')) {
          if (data.onboarding.length === 1) {
            // Single onboarding group - go directly to onboarding
            $router.push({
              name: 'onboarding-dealership',
              query: {
                dealerGroupId: data.onboarding[0].id,
                dealerShipId: '0',
              },
            })
          } else {
            // Multiple onboarding groups - show selection modal
            commit('SET_ONBOARDING_GROUPS_MODAL', true, { root: true })
          }
        }
      } else if (
        (!data.active || data.active.length === 0) &&
        (!data.onboarding || data.onboarding.length === 0)
      ) {
        NotifyService.create({
          type: 'negative',
          message: 'No active/onboarding dealer groups found. Please contact support. Logging out.',
        })
        AuthService.logout({ shouldRedirect: true })
      }

      return data
    },
  },
  getters: {
    allDealership() {
      return {
        id: 0,
        name: 'All Dealerships',
      }
    },
    dealer(state, getters, rootState) {
      const dealers = state.dealers || []
      const dealer = find(dealers, {
        id: +rootState.settings.dealerGroupId,
      })

      // if (dealer !== undefined) {
      //   dealer.castUnknownLeadsAs = 'unknown'
      // }

      return dealer
    },
    currentDealerships(state, getters, rootState) {
      return +rootState.settings.dealerShipId === 0
        ? getters.dealerships.map((e) => +e.id)
        : rootState.settings.dealerShipId.split(',').map(Number)
    },
    dealerships(state, getters) {
      if ($router.currentRoute.value.meta.customGroup) {
        const { customGroup } = useCustomGroup()
        return customGroup.value?.allDealerships ?? []
      }

      let dealerships = []
      if (getters.dealer) {
        dealerships = getters.dealer.dealerships.map((item) => ({
          ...item,
          title: item.name,
        }))
      }
      return dealerships
    },
    dealershipsList(state, getters) {
      return [getters.allDealership, ...getters.dealerships]
    },
    budgetCampaignView(state, getters, rootState) {
      if (state.dealers) {
        const dealer = find(state.dealers, {
          id: +rootState.settings.dealerGroupId,
        })

        return dealer.budgetCampaignView
      }

      return 0
    },
  },
}
